import OutSide from './OutSide'
export default OutSide
